import { Form, FormikProvider, useFormik } from 'formik';
import QuillDelta from 'quill-delta';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import * as Yup from 'yup';

import * as graphql from '@treams/treams-network';
import { Label, Modal, Popover, QuillInput } from '@treams/treams-ui';

const quillValidator = Yup.object({
	ops: Yup.array().min(1).required(),
});

export function ComplimentCreateModalWithID(props: { userID: string }) {
	const query = graphql.useUserQuery({ variables: { id: props.userID } });

	return query.data ? <ComplimentCreateModal user={query.data.user as graphql.User} /> : null;
}

function ComplimentCreateModal({ user }: { user: graphql.User }) {
	const history = useHistory();
	const { t } = useTranslation();
	const returnUrl = `/users/${user.id}/feedback/compliments`;

	const [create] = graphql.useCreateComplimentMutation();

	const createCompliment = async (text: QuillDelta) => {
		await create({
			variables: {
				input: {
					userID: user.id,
					text,
				},
			},
		});

		history.push(`/users/${user.id}/feedback/compliments/thank-you`);
	};

	const formik = useFormik({
		initialValues: { text: new QuillDelta() },
		validationSchema: Yup.object({
			text: quillValidator.required(),
		}).required(),
		onSubmit: (values) => {
			return createCompliment(values.text);
		},
	});

	return (
		<Popover visible center>
			<Modal>
				<Modal.Header
					closeLink={returnUrl}
					title={t('compliments.give.title', { firstName: user.firstName })}
				/>
				<Modal.Contents>
					<FormikProvider value={formik}>
						<Form>
							<Label mb={2}>{t('compliments.give.textField.label')}</Label>
							<QuillInput.Formik name="text" />
						</Form>
					</FormikProvider>
				</Modal.Contents>

				<Modal.FormFooter
					cancelLink={returnUrl}
					onSave={() => formik.submitForm()}
					saveTitle={t('compliments.give.button.create')}
				/>
			</Modal>
		</Popover>
	);
}
